import { useMemo } from 'react';

/**
 * Returns an object mapping filter keywords to their corresponding filter actions in the store
 * @returns
 */
export const useFilterKeywordToFilterActions: () => {
	[k: string]: {
		setOption: (
			option:
				| import('../../../common/constants/filters/select-filter/types').SelectFilterOption
				| import('../../../common/constants/filters/select-filter/types').SelectFilterOption[],
			customValue?: Record<string, string>,
			setSelectedProduct?: import('../../..').ProductKeys,
		) => void | Promise<void>;
		loadInitialOptions: () => void | Promise<void>;
		setLookupInput: (query: string) => void | Promise<void>;
		clearLookupInput: () => void | Promise<void>;
		clearOptions: () => void | Promise<void>;
	};
} = () => {
	return useMemo(() => {
		return {};
	}, []);
};
